// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"53b06204","462":"0db6aa4e","890":"713c194d"}[chunkId] + ".chunk.js";
};